import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63d16ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Plazas restantes:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin entrega de listas:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin de inscripción:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pagos:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas entregadas:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas legales:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas de luz:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas de oscuridad:", -1))
const _hoisted_9 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_10 = { style: {"text-align":"center","font-size":"12px","margin-top":"4px"} }

import { esUsuarioBye } from "@/utils/bye";
import { Torneo, TorneoGestionInfoDTO } from "@/interfaces/Torneo";
import { computed, ref } from "vue";
import ModalModificarTorneo from "./ModalModificarTorneo.vue";
import { getListasTorneoAsync, getTorneo } from "@/services/TorneosService";
import ModalModificarBasesTorneo from "./ModalModificarBasesTorneo.vue";
import CardAddTorneoCircuito from "./CardAddTorneoCircuito.vue";
import { esPorJornadas, nombreEvento, textosEvento } from "@/Constant/FormatoTorneo";
import ModalHandlerMostrarListas from "./ModalHandlerMostrarListas.vue";
import ModalHandlerMostrarClasificacion from "./ModalHandlerMostrarClasificacion.vue";
import { ClassificationType } from "@/Constant/TipoClasificacion";
import ModalError from "../Commons/ModalError.vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import LoadingLOTR from "../Commons/LoadingLOTR.vue";
import { ListaCompletaDTO } from "@/interfaces/Lista";
import jsPDF from "jspdf";
import { descargarListasPDF } from "@/utils/descargarListas";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'CardGestionTorneo',
  props: {
    torneo: {}
  },
  setup(__props: any) {

const props = __props;
// Liga y Copa: "modificada" en femenino
const esLiga = computed(() => esPorJornadas(props.torneo?.torneo.formatoTorneo));
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const showModificarTorneoModal = ref<boolean>(false);
const showModificarBasesTorneoModal = ref<boolean>(false);
const showModalHandlerMostrarListas = ref<boolean>(false);
const showModalHandlerMostrarClasificacion = ref<boolean>(false);
const mostrarListas = ref(props.torneo?.torneo.mostrarListas);
const mostrarClasificacion = ref(props.torneo?.torneo.mostrarClasificacion);

const progressPDF = ref<number>(0);

const idTorneo = ref<number>(0);
const isLoading = ref<boolean>(false);
const isDownloading = ref<boolean>(false);
const torneoMod = ref<Torneo>({
  idTorneo: 0,
  idUsuario: 0,
  nombreTorneo: "",
  descripcionTorneo: "",
  fechaInicioTorneo: "",
  fechaFinTorneo: "",
  precioTorneo: 0,
  numeroPartidas: 0,
  puntosTorneo: 0,
  estadoTorneo: "ESPERANDO",
  lugarTorneo: "",
  tipoTorneo: "Individual",
  esPrivadoTorneo: false,
  idRangoTorneo: 0,
  esMatchedPlayTorneo: false,
  fechaEntregaListas: "",
  fechaFinInscripcion: "",
  basesTorneo: "",
  cartelTorneo: "",
  metodosPago: [],
  horaInicioTorneo: "",
  horaFinTorneo: "",
  tieneBases: false,
  inicioInscripciones: "",
  listasPorJugador: 0,
  mostrarListas: false,
  mostrarClasificacion: false,
  classificationType: ClassificationType.NORMAL,
});

// Las cifras, sin el bye: no es nadie a quien contar ni reclamar
const inscritos = computed(() =>
  (props.torneo?.inscripciones ?? []).filter(i => !esUsuarioBye(i.idUsuario, i.nick))
);

const plazasRestantes = computed(() => {
  if (
    !props.torneo ||
    inscritos.value.length == undefined ||
    props.torneo.torneo.limiteParticipantes == null
  ) {
    return "Sin límite";
  }
  return (
    props.torneo.torneo.limiteParticipantes - inscritos.value.length
  );
});

const listasLuz = computed(() => {
  if (!props.torneo) return 0;
  return inscritos.value.filter(i => i.bando === "good").length;
});

const listasOscuridad = computed(() => {
  if (!props.torneo) return 0;
  return inscritos.value.filter(i => i.bando === "evil").length;
});

const totalInscripciones = computed(() => {
  return props.torneo ? inscritos.value.length : 0;
});

const pagosRealizados = computed(() => {
  if (!props.torneo) return 0;
  return inscritos.value.filter(
    inscripcion => inscripcion.esPago === "SI"
  ).length;
});

const listasLegales = computed(() => {
  if (!props.torneo) return 0;
  return inscritos.value.filter(
    inscripcion => inscripcion.estadoLista === "OK"
  ).length;
});

const listasEntregadas = computed(() => {
  if (!props.torneo) return 0;
  return inscritos.value.filter(
    inscripcion =>
      inscripcion.estadoLista === "ENTREGADA" ||
      inscripcion.estadoLista === "OK" ||
      inscripcion.estadoLista === "ILEGAL"
  ).length;
});

const formatDate = (date: string | null | undefined) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

const modificarTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const modificarBasesTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarBasesTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const cerrarModal = async () => {
  showModificarBasesTorneoModal.value = false;
  showModificarTorneoModal.value = false;
  showModalHandlerMostrarListas.value = false;
  showModalHandlerMostrarClasificacion.value = false;
};

const onCambioMostrarListas = (nuevoValor: boolean) => {
  mostrarListas.value = nuevoValor;
  showModalHandlerMostrarListas.value = false;
};

const onCambioMostrarClasificacion = (nuevoValor: boolean) => {
  mostrarClasificacion.value = nuevoValor;
  showModalHandlerMostrarClasificacion.value = false;
};

const handlerMostrarListas = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarListas.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const handlerMostrarClasificacion = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarClasificacion.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

function chunkArray<T>(arr: T[], size: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

const descargarListasTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    isDownloading.value = true;
    const response = await getListasTorneoAsync(idTorneo.value);
    const listas: ListaCompletaDTO[] = response.data;
    await descargarListasPDF(
      listas,
      props.torneo?.torneo.nombreTorneo ?? "",
      undefined,
      (current, total) => { progressPDF.value = Math.round((current / total) * 100); }
    );
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    progressPDF.value = 0;
    isDownloading.value = false;
    showErrorModal.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.torneo)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.torneo.torneo.nombreTorneo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _hoisted_1,
                  _createTextVNode(" " + _toDisplayString(plazasRestantes.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaEntregaListas)), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaFinInscripcion)), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(pagosRealizados.value) + "/" + _toDisplayString(totalInscripciones.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(listasEntregadas.value) + "/" + _toDisplayString(totalInscripciones.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(listasLegales.value) + "/" + _toDisplayString(totalInscripciones.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(listasLuz.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(listasOscuridad.value), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: modificarTorneo,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Modificar " + _toDisplayString(_unref(nombreEvento)(props.torneo?.torneo.formatoTorneo).toLowerCase()), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: modificarBasesTorneo,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Modificar bases")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: handlerMostrarListas,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mostrarListas.value ? "Ocultar" : "Mostrar") + " Listas", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: handlerMostrarClasificacion,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mostrarClasificacion.value ? "Ocultar" : "Mostrar") + " Clasificación", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: descargarListasTorneo,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Descargar Listas")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _renderSlot(_ctx.$slots, "acciones"),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(CardAddTorneoCircuito, {
                          idTorneo: props.torneo?.torneo.idTorneo!,
                          formato: props.torneo?.torneo.formatoTorneo
                        }, null, 8, ["idTorneo", "formato"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _createVNode(ModalModificarTorneo, {
      isVisible: showModificarTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalModificarBasesTorneo, {
      isVisible: showModificarBasesTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarListas, {
      isVisible: showModalHandlerMostrarListas.value,
      torneo: torneoMod.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarListas
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarClasificacion, {
      isVisible: showModalHandlerMostrarClasificacion.value,
      torneo: torneoMod.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarClasificacion
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: `${_unref(nombreEvento)(props.torneo?.torneo.formatoTorneo)} ${esLiga.value ? 'modificada' : 'modificado'} con éxito.`,
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: `No se ha podido modificar ${_unref(textosEvento)(props.torneo?.torneo.formatoTorneo).el}. Intentalo de nuevo y si el error persiste contacta con el administrador.`,
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(LoadingLOTR, {
      isVisible: isDownloading.value,
      mensaje: "Generando PDF, por favor espera..."
    }, {
      default: _withCtx(() => [
        (isDownloading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(progressPDF.value) + "% ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})